import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import type { ChangeVehicleInterstateProps } from './changeVehicle/ChangeVehicle.interstate';
import ChangeVehicleInterstate from './changeVehicle/ChangeVehicle.interstate';
import { StyledChangeVehicleActivity } from './ChangeVehicleActivity.style';

const ChangeVehicleActivity = (props: ChangeVehicleInterstateProps) => {
    const theme = useInterstateTheme();

    return (
        <StyledChangeVehicleActivity theme={theme}>
            <div data-testid="activities-change-vehicle-container" className="activities-change-vehicle">
                <ChangeVehicleInterstate {...props} />
            </div>
        </StyledChangeVehicleActivity>
    );
};

export default ChangeVehicleActivity;
